module.exports = __webpack_public_path__ + "img/italic-icon-white.78b9fe04.svg";